module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_pp2_4.aba4ed1f.png";